var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecent = function SvgRecent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59534 15.8355C7.0672 17.1748 7.96156 18.3245 9.14365 19.1114C10.3257 19.8982 11.7315 20.2795 13.1492 20.198C14.5669 20.1164 15.9196 19.5762 17.0036 18.659C18.0876 17.7417 18.8442 16.497 19.1593 15.1124C19.4744 13.7278 19.3309 12.2783 18.7506 10.9823C18.1702 9.68625 17.1844 8.61396 15.9416 7.92695C14.6989 7.23994 13.2665 6.97542 11.8603 7.17326C10.4542 7.3711 9.15038 8.02058 8.14543 9.02383",
    stroke: "#ED7E00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96026 5.28447C8.07929 4.9458 8.45034 4.76774 8.78901 4.88677C9.12769 5.0058 9.30575 5.37685 9.18671 5.71553L7.96026 5.28447ZM7.4019 8.83347L7.15685 9.43551C6.83572 9.3048 6.67371 8.94504 6.78867 8.61794L7.4019 8.83347ZM10.886 9.54986C11.2185 9.6852 11.3784 10.0644 11.243 10.3969C11.1077 10.7294 10.7284 10.8893 10.3959 10.7539L10.886 9.54986ZM9.18671 5.71553L8.01513 9.049L6.78867 8.61794L7.96026 5.28447L9.18671 5.71553ZM7.64695 8.23143L10.886 9.54986L10.3959 10.7539L7.15685 9.43551L7.64695 8.23143Z",
    fill: "#ED7E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8417 11.7021C12.8417 11.3432 12.5506 11.0521 12.1917 11.0521C11.8327 11.0521 11.5417 11.3432 11.5417 11.7021H12.8417ZM12.1917 14.0288H11.5417C11.5417 14.2972 11.7067 14.5381 11.9571 14.635L12.1917 14.0288ZM13.9591 15.4096C14.2939 15.5392 14.6703 15.3728 14.7998 15.038C14.9294 14.7032 14.763 14.3268 14.4282 14.1972L13.9591 15.4096ZM11.5417 11.7021V14.0288H12.8417V11.7021H11.5417ZM11.9571 14.635L13.9591 15.4096L14.4282 14.1972L12.4262 13.4226L11.9571 14.635Z",
    fill: "#2F353B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recent.8314a9b1.svg";
export { ForwardRef as ReactComponent };